<template>
    <CModal
      :title="title"
      :color="color"
      :show.sync="showModal"
      class="basic-modal-color"
    >   
        <CForm id="guest_confirm_form" method="POST" enctype="multipart/form-data">
          <CRow>      
            <CCol md="12" style="text-align: center;">
              ¿Estás seguro que deseas enviar {{ modeLabel }} al invitado?
              <br /> <br/>
              <b>{{form.name}}</b>
              <br /> <br/>
              La invitación será enviada por el Whatsapp que haya sido registrado con el Invitado.
              <br /> <br/>
              <CBadge v-if="!event || event.image == ''" color="danger" style="width: 100%;text-wrap: wrap; padding: 5px;">El evento no tiene una imagen de invitación cargada<br/>{{ modeWarningText }}</CBadge>
            </CCol>              
          </CRow>
        </CForm>
        <template #footer>
          <CButton @click="closeModal" color="secondary">Cancelar</CButton>
          <CButton @click="sendInvitation" :color="color">Enviar {{ modeButtonLabel }}</CButton>
        </template>
    </CModal>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required, minLength, minValue, helpers } from "vuelidate/lib/validators"
import store from '@/store';
import ws from '@/services/events_guests';

export default {
  name: 'SendInvitationModal',
  props: {
  },
  components: {
  },
  data () {
    return {
      event: false,
      showModal: false,
      title: "Enviar Invitación",
      color: "info",
      isEdit: false,
      form: this.getEmptyForm(),
      submitted: false,      
      classesOptions: [],
      statusOptions: [],
      mode: 'reminder',
    }
  },
  mounted: async function() {    
    
  },
  methods: {
    showSendModal (item, event, mode = 'reminder') {
      this.showModal = true;
      this.color = "info";
      this.mode = mode;
      this.title = this.mode === 'invitation' ? 'Enviar Invitación' : 'Enviar Recordatorio';
      this.isEdit = false;
      this.submitted = false;

      this.event = event;

      this.form = {
          id: item.id,
          name: item.name,
          tickets: item.tickets,
          table: item.table,
      };

      console.log(this.form);
    },
    async sendInvitation (item) {
      this.loading();

      let response = this.mode === 'invitation'
        ? await ws.sendInvitation({id: this.form.id})
        : await ws.sendReminder({id: this.form.id});

      this.loaded();
      this.showToast(response.type, response.message);

      if(response.type == "success"){
        this.closeModal();
      }                 
    },
    closeModal () {
      this.showModal = false;

      this.form = this.getEmptyForm()
      this.submitted = false
      this.$v.$reset()
    },
    getEmptyForm () {
      return {
          id: 0,
      }
    },
    checkIfValid (fieldName) {
      const field = this.$v.form[fieldName]
      if (!field.$dirty) {
        return null
      }
      
      return !(field.$invalid || field.$model === '')
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  },
  computed: {
    formString () { return JSON.stringify(this.form, null, 4) },
    isValid () { return !this.$v.form.$invalid },
    isDirty () { return this.$v.form.$anyDirty },
    modeLabel () { return this.mode === 'invitation' ? 'la invitación' : 'el recordatorio' },
    modeButtonLabel () { return this.mode === 'invitation' ? 'Invitación' : 'Recordatorio' },
    modeWarningText () { return this.mode === 'invitation' ? 'la invitación será enviada con una imagen con el logo de Confirma.me' : 'el recordatorio será enviado con una imagen con el logo de Confirma.me' },
  },
  mixins: [validationMixin],
  validations: {
    form: {
      id: {        
      },
    }
  },
}
</script>
<style>
.basic-modal-color .modal-header{
  background-color: #668269 !important;
}
</style>